export const enum PricingType {
  AllIn = 0,
  PerHour = 1,
}